export function checkFiletype(
  file: File,
  acceptedFileExtensions: string[]
): boolean {
  const fileType = file.name.substring(file.name.lastIndexOf("."));
  return acceptedFileExtensions.includes(fileType);
}
